export default {
  patients: {
    label: 'Patients',
    warning: 'Warning!',
    patientsList: 'Patients List',
    viewPatients: 'View Patients',
    noPatients: "There are no patients yet, let's add the first one!",
    viewPatient: 'View Patient',
    createPatient: 'Create Patient',
    newPatient: 'New Patient',
    editPatient: 'Edit Patient',
    updatePatient: 'Update Patient',
    successfullyCreated: 'Successfully created patient',
    successfullyAddedNote: 'Successfully added the new note',
    successfullyAddedRelatedPerson: 'Successfully added a new related person',
    successfullyUpdated: 'Successfully updated information for ',
    possibleDuplicatePatient: 'Possible duplicate patient:',
    duplicatePatientWarning:
      'Patient with matching information found in database. Are you sure you want to create this patient?',
  },
}
